import { render, staticRenderFns } from "./app-sendOrderItem.vue?vue&type=template&id=3c27679d"
import script from "./app-sendOrderItem.vue?vue&type=script&lang=js"
export * from "./app-sendOrderItem.vue?vue&type=script&lang=js"
import style0 from "./app-sendOrderItem.vue?vue&type=style&index=0&id=3c27679d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports